import { Country } from './country';
export const phoneNumberPrefixes = {
    [Country.AU]: '+61',
    [Country.CA]: '+1',
    [Country.CH]: '+41',
    [Country.ES]: '+34',
    [Country.ID]: '+62',
    [Country.IE]: '+353',
    [Country.IT]: '+39',
    [Country.MY]: '+60',
    [Country.NO]: '+47',
    [Country.SG]: '+65',
    [Country.GB]: '+44',
    [Country.US]: '+1'
};
export const isValidPhoneNumber = (value) => {
    var _a;
    const matchesPattern = value.match(/^\+[0-9\- ()]*$/) !== null;
    const digitCount = ((_a = value.match(/\d/g)) !== null && _a !== void 0 ? _a : []).length;
    return matchesPattern && digitCount >= 9 && digitCount <= 15;
};
export const charityCountries = [
    {
        code: 'au',
        name: 'Australia'
    },
    {
        code: 'ca',
        name: 'Canada'
    },
    {
        code: 'id',
        name: 'Indonesia'
    },
    {
        code: 'ie',
        name: 'Ireland'
    },
    {
        code: 'it',
        name: 'Italy'
    },
    {
        code: 'my',
        name: 'Malaysia'
    },
    {
        code: 'no',
        name: 'Norway'
    },
    {
        code: 'sg',
        name: 'Singapore'
    },
    {
        code: 'za',
        name: 'South Africa'
    },
    {
        code: 'es',
        name: 'Spain'
    },
    {
        code: 'ch',
        name: 'Switzerland'
    },
    {
        code: 'gb',
        name: 'United Kingdom'
    },
    {
        code: 'us',
        name: 'United States'
    }
];
export const otherCountries = [
    {
        code: 'af',
        name: 'Afghanistan'
    },
    {
        code: 'ax',
        name: 'Åland Islands'
    },
    {
        code: 'al',
        name: 'Albania'
    },
    {
        code: 'dz',
        name: 'Algeria'
    },
    {
        code: 'as',
        name: 'American Samoa'
    },
    {
        code: 'ad',
        name: 'Andorra'
    },
    {
        code: 'ao',
        name: 'Angola'
    },
    {
        code: 'ai',
        name: 'Anguilla'
    },
    {
        code: 'aq',
        name: 'Antarctica'
    },
    {
        code: 'ag',
        name: 'Antigua and Barbuda'
    },
    {
        code: 'ar',
        name: 'Argentina'
    },
    {
        code: 'am',
        name: 'Armenia'
    },
    {
        code: 'aw',
        name: 'Aruba'
    },
    {
        code: 'at',
        name: 'Austria'
    },
    {
        code: 'az',
        name: 'Azerbaijan'
    },
    {
        code: 'bs',
        name: 'Bahamas'
    },
    {
        code: 'bh',
        name: 'Bahrain'
    },
    {
        code: 'bd',
        name: 'Bangladesh'
    },
    {
        code: 'bb',
        name: 'Barbados'
    },
    {
        code: 'by',
        name: 'Belarus'
    },
    {
        code: 'be',
        name: 'Belgium'
    },
    {
        code: 'bz',
        name: 'Belize'
    },
    {
        code: 'bj',
        name: 'Benin'
    },
    {
        code: 'bm',
        name: 'Bermuda'
    },
    {
        code: 'bt',
        name: 'Bhutan'
    },
    {
        code: 'bo',
        name: 'Bolivia, Plurinational State of'
    },
    {
        code: 'bq',
        name: 'Bonaire, Sint Eustatius and Saba'
    },
    {
        code: 'ba',
        name: 'Bosnia and Herzegovina'
    },
    {
        code: 'bw',
        name: 'Botswana'
    },
    {
        code: 'bv',
        name: 'Bouvet Island'
    },
    {
        code: 'br',
        name: 'Brazil'
    },
    {
        code: 'io',
        name: 'British Indian Ocean Territory'
    },
    {
        code: 'bn',
        name: 'Brunei Darussalam'
    },
    {
        code: 'bg',
        name: 'Bulgaria'
    },
    {
        code: 'bf',
        name: 'Burkina Faso'
    },
    {
        code: 'bi',
        name: 'Burundi'
    },
    {
        code: 'kh',
        name: 'Cambodia'
    },
    {
        code: 'cm',
        name: 'Cameroon'
    },
    {
        code: 'cv',
        name: 'Cape Verde'
    },
    {
        code: 'ky',
        name: 'Cayman Islands'
    },
    {
        code: 'cf',
        name: 'Central African Republic'
    },
    {
        code: 'td',
        name: 'Chad'
    },
    {
        code: 'cl',
        name: 'Chile'
    },
    {
        code: 'cn',
        name: 'China'
    },
    {
        code: 'cx',
        name: 'Christmas Island'
    },
    {
        code: 'cc',
        name: 'Cocos (Keeling) Islands'
    },
    {
        code: 'co',
        name: 'Colombia'
    },
    {
        code: 'km',
        name: 'Comoros'
    },
    {
        code: 'cg',
        name: 'Congo'
    },
    {
        code: 'cd',
        name: 'Congo, the Democratic Republic of the'
    },
    {
        code: 'ck',
        name: 'Cook Islands'
    },
    {
        code: 'cr',
        name: 'Costa Rica'
    },
    {
        code: 'ci',
        name: 'Côte d\'Ivoire'
    },
    {
        code: 'hr',
        name: 'Croatia'
    },
    {
        code: 'cu',
        name: 'Cuba'
    },
    {
        code: 'cw',
        name: 'Curaçao'
    },
    {
        code: 'cy',
        name: 'Cyprus'
    },
    {
        code: 'cz',
        name: 'Czech Republic'
    },
    {
        code: 'dk',
        name: 'Denmark'
    },
    {
        code: 'dj',
        name: 'Djibouti'
    },
    {
        code: 'dm',
        name: 'Dominica'
    },
    {
        code: 'do',
        name: 'Dominican Republic'
    },
    {
        code: 'ec',
        name: 'Ecuador'
    },
    {
        code: 'eg',
        name: 'Egypt'
    },
    {
        code: 'sv',
        name: 'El Salvador'
    },
    {
        code: 'gq',
        name: 'Equatorial Guinea'
    },
    {
        code: 'er',
        name: 'Eritrea'
    },
    {
        code: 'ee',
        name: 'Estonia'
    },
    {
        code: 'et',
        name: 'Ethiopia'
    },
    {
        code: 'fk',
        name: 'Falkland Islands (Malvinas)'
    },
    {
        code: 'fo',
        name: 'Faroe Islands'
    },
    {
        code: 'fj',
        name: 'Fiji'
    },
    {
        code: 'fi',
        name: 'Finland'
    },
    {
        code: 'fr',
        name: 'France'
    },
    {
        code: 'gf',
        name: 'French Guiana'
    },
    {
        code: 'pf',
        name: 'French Polynesia'
    },
    {
        code: 'tf',
        name: 'French Southern Territories'
    },
    {
        code: 'ga',
        name: 'Gabon'
    },
    {
        code: 'gm',
        name: 'Gambia'
    },
    {
        code: 'ge',
        name: 'Georgia'
    },
    {
        code: 'de',
        name: 'Germany'
    },
    {
        code: 'gh',
        name: 'Ghana'
    },
    {
        code: 'gi',
        name: 'Gibraltar'
    },
    {
        code: 'gr',
        name: 'Greece'
    },
    {
        code: 'gl',
        name: 'Greenland'
    },
    {
        code: 'gd',
        name: 'Grenada'
    },
    {
        code: 'gp',
        name: 'Guadeloupe'
    },
    {
        code: 'gu',
        name: 'Guam'
    },
    {
        code: 'gt',
        name: 'Guatemala'
    },
    {
        code: 'gg',
        name: 'Guernsey'
    },
    {
        code: 'gn',
        name: 'Guinea'
    },
    {
        code: 'gw',
        name: 'Guinea-Bissau'
    },
    {
        code: 'gy',
        name: 'Guyana'
    },
    {
        code: 'ht',
        name: 'Haiti'
    },
    {
        code: 'hm',
        name: 'Heard Island and McDonald Islands'
    },
    {
        code: 'va',
        name: 'Holy See (Vatican City State)'
    },
    {
        code: 'hn',
        name: 'Honduras'
    },
    {
        code: 'hk',
        name: 'Hong Kong'
    },
    {
        code: 'hu',
        name: 'Hungary'
    },
    {
        code: 'is',
        name: 'Iceland'
    },
    {
        code: 'in',
        name: 'India'
    },
    {
        code: 'id',
        name: 'Indonesia'
    },
    {
        code: 'ir',
        name: 'Iran, Islamic Republic of'
    },
    {
        code: 'iq',
        name: 'Iraq'
    },
    {
        code: 'im',
        name: 'Isle of Man'
    },
    {
        code: 'il',
        name: 'Israel'
    },
    {
        code: 'jm',
        name: 'Jamaica'
    },
    {
        code: 'jp',
        name: 'Japan'
    },
    {
        code: 'je',
        name: 'Jersey'
    },
    {
        code: 'jo',
        name: 'Jordan'
    },
    {
        code: 'kz',
        name: 'Kazakhstan'
    },
    {
        code: 'ke',
        name: 'Kenya'
    },
    {
        code: 'ki',
        name: 'Kiribati'
    },
    {
        code: 'kp',
        name: 'Korea, Democratic People\'s Republic of'
    },
    {
        code: 'kr',
        name: 'Korea, Republic of'
    },
    {
        code: 'kw',
        name: 'Kuwait'
    },
    {
        code: 'kg',
        name: 'Kyrgyzstan'
    },
    {
        code: 'la',
        name: 'Lao People\'s Democratic Republic'
    },
    {
        code: 'lv',
        name: 'Latvia'
    },
    {
        code: 'lb',
        name: 'Lebanon'
    },
    {
        code: 'ls',
        name: 'Lesotho'
    },
    {
        code: 'lr',
        name: 'Liberia'
    },
    {
        code: 'ly',
        name: 'Libya'
    },
    {
        code: 'li',
        name: 'Liechtenstein'
    },
    {
        code: 'lt',
        name: 'Lithuania'
    },
    {
        code: 'lu',
        name: 'Luxembourg'
    },
    {
        code: 'mo',
        name: 'Macao'
    },
    {
        code: 'mk',
        name: 'North Macedonia'
    },
    {
        code: 'mg',
        name: 'Madagascar'
    },
    {
        code: 'mw',
        name: 'Malawi'
    },
    {
        code: 'my',
        name: 'Malaysia'
    },
    {
        code: 'mv',
        name: 'Maldives'
    },
    {
        code: 'ml',
        name: 'Mali'
    },
    {
        code: 'mt',
        name: 'Malta'
    },
    {
        code: 'mh',
        name: 'Marshall Islands'
    },
    {
        code: 'mq',
        name: 'Martinique'
    },
    {
        code: 'mr',
        name: 'Mauritania'
    },
    {
        code: 'mu',
        name: 'Mauritius'
    },
    {
        code: 'yt',
        name: 'Mayotte'
    },
    {
        code: 'mx',
        name: 'Mexico'
    },
    {
        code: 'fm',
        name: 'Micronesia, Federated States of'
    },
    {
        code: 'md',
        name: 'Moldova, Republic of'
    },
    {
        code: 'mc',
        name: 'Monaco'
    },
    {
        code: 'mn',
        name: 'Mongolia'
    },
    {
        code: 'me',
        name: 'Montenegro'
    },
    {
        code: 'ms',
        name: 'Montserrat'
    },
    {
        code: 'ma',
        name: 'Morocco'
    },
    {
        code: 'mz',
        name: 'Mozambique'
    },
    {
        code: 'mm',
        name: 'Myanmar'
    },
    {
        code: 'na',
        name: 'Namibia'
    },
    {
        code: 'nr',
        name: 'Nauru'
    },
    {
        code: 'np',
        name: 'Nepal'
    },
    {
        code: 'nl',
        name: 'Netherlands'
    },
    {
        code: 'nc',
        name: 'New Caledonia'
    },
    {
        code: 'nz',
        name: 'New Zealand'
    },
    {
        code: 'ni',
        name: 'Nicaragua'
    },
    {
        code: 'ne',
        name: 'Niger'
    },
    {
        code: 'ng',
        name: 'Nigeria'
    },
    {
        code: 'nu',
        name: 'Niue'
    },
    {
        code: 'nf',
        name: 'Norfolk Island'
    },
    {
        code: 'mp',
        name: 'Northern Mariana Islands'
    },
    {
        code: 'om',
        name: 'Oman'
    },
    {
        code: 'pk',
        name: 'Pakistan'
    },
    {
        code: 'pw',
        name: 'Palau'
    },
    {
        code: 'pa',
        name: 'Panama'
    },
    {
        code: 'pg',
        name: 'Papua New Guinea'
    },
    {
        code: 'py',
        name: 'Paraguay'
    },
    {
        code: 'pe',
        name: 'Peru'
    },
    {
        code: 'ph',
        name: 'Philippines'
    },
    {
        code: 'pn',
        name: 'Pitcairn'
    },
    {
        code: 'pl',
        name: 'Poland'
    },
    {
        code: 'pt',
        name: 'Portugal'
    },
    {
        code: 'pr',
        name: 'Puerto Rico'
    },
    {
        code: 'qa',
        name: 'Qatar'
    },
    {
        code: 're',
        name: 'Réunion'
    },
    {
        code: 'ro',
        name: 'Romania'
    },
    {
        code: 'ru',
        name: 'Russian Federation'
    },
    {
        code: 'rw',
        name: 'Rwanda'
    },
    {
        code: 'bl',
        name: 'Saint Barthélemy'
    },
    {
        code: 'sh',
        name: 'Saint Helena, Ascension and Tristan da Cunha'
    },
    {
        code: 'kn',
        name: 'Saint Kitts and Nevis'
    },
    {
        code: 'lc',
        name: 'Saint Lucia'
    },
    {
        code: 'mf',
        name: 'Saint Martin (French part)'
    },
    {
        code: 'pm',
        name: 'Saint Pierre and Miquelon'
    },
    {
        code: 'vc',
        name: 'Saint Vincent and the Grenadines'
    },
    {
        code: 'ws',
        name: 'Samoa'
    },
    {
        code: 'sm',
        name: 'San Marino'
    },
    {
        code: 'st',
        name: 'Sao Tome and Principe'
    },
    {
        code: 'sa',
        name: 'Saudi Arabia'
    },
    {
        code: 'sn',
        name: 'Senegal'
    },
    {
        code: 'rs',
        name: 'Serbia'
    },
    {
        code: 'sc',
        name: 'Seychelles'
    },
    {
        code: 'sl',
        name: 'Sierra Leone'
    },
    {
        code: 'sg',
        name: 'Singapore'
    },
    {
        code: 'sx',
        name: 'Sint Maarten (Dutch part)'
    },
    {
        code: 'sk',
        name: 'Slovakia'
    },
    {
        code: 'si',
        name: 'Slovenia'
    },
    {
        code: 'sb',
        name: 'Solomon Islands'
    },
    {
        code: 'so',
        name: 'Somalia'
    },
    {
        code: 'gs',
        name: 'South Georgia and the South Sandwich Islands'
    },
    {
        code: 'ss',
        name: 'South Sudan'
    },
    {
        code: 'lk',
        name: 'Sri Lanka'
    },
    {
        code: 'sd',
        name: 'Sudan'
    },
    {
        code: 'sr',
        name: 'Suriname'
    },
    {
        code: 'sj',
        name: 'Svalbard and Jan Mayen'
    },
    {
        code: 'sz',
        name: 'Swaziland'
    },
    {
        code: 'se',
        name: 'Sweden'
    },
    {
        code: 'tw',
        name: 'Taiwan, Province of China'
    },
    {
        code: 'tj',
        name: 'Tajikistan'
    },
    {
        code: 'tz',
        name: 'Tanzania, United Republic of'
    },
    {
        code: 'th',
        name: 'Thailand'
    },
    {
        code: 'tl',
        name: 'Timor-Leste'
    },
    {
        code: 'tg',
        name: 'Togo'
    },
    {
        code: 'tk',
        name: 'Tokelau'
    },
    {
        code: 'to',
        name: 'Tonga'
    },
    {
        code: 'tt',
        name: 'Trinidad and Tobago'
    },
    {
        code: 'tn',
        name: 'Tunisia'
    },
    {
        code: 'tr',
        name: 'Turkey'
    },
    {
        code: 'tm',
        name: 'Turkmenistan'
    },
    {
        code: 'tc',
        name: 'Turks and Caicos Islands'
    },
    {
        code: 'tv',
        name: 'Tuvalu'
    },
    {
        code: 'ug',
        name: 'Uganda'
    },
    {
        code: 'ua',
        name: 'Ukraine'
    },
    {
        code: 'ae',
        name: 'United Arab Emirates'
    },
    {
        code: 'um',
        name: 'United States Minor Outlying Islands'
    },
    {
        code: 'uy',
        name: 'Uruguay'
    },
    {
        code: 'uz',
        name: 'Uzbekistan'
    },
    {
        code: 'vu',
        name: 'Vanuatu'
    },
    {
        code: 've',
        name: 'Venezuela, Bolivarian Republic of'
    },
    {
        code: 'vn',
        name: 'Vietnam'
    },
    {
        code: 'vg',
        name: 'Virgin Islands, British'
    },
    {
        code: 'vi',
        name: 'Virgin Islands, U.S.'
    },
    {
        code: 'wf',
        name: 'Wallis and Futuna'
    },
    {
        code: 'eh',
        name: 'Western Sahara'
    },
    {
        code: 'ye',
        name: 'Yemen'
    },
    {
        code: 'zm',
        name: 'Zambia'
    },
    {
        code: 'zw',
        name: 'Zimbabwe'
    }
];
export const allCountries = [...charityCountries, ...otherCountries];
export function getCountryByCode(code) {
    return allCountries.find(c => c.code === code);
}
export const dialCodes = {
    bd: '+880',
    be: '+32',
    bf: '+226',
    bg: '+359',
    ba: '+387',
    bb: '+1246',
    wf: '+681',
    bl: '+590',
    bm: '+1441',
    bn: '+673',
    bo: '+591',
    bh: '+973',
    bi: '+257',
    bj: '+229',
    bt: '+975',
    jm: '+1876',
    bw: '+267',
    ws: '+685',
    bq: '+599',
    br: '+55',
    bs: '+1242',
    by: '+375',
    bz: '+501',
    ru: '+7',
    rw: '+250',
    rs: '+381',
    tl: '+670',
    re: '+262',
    tm: '+993',
    tj: '+992',
    ro: '+40',
    tk: '+690',
    gw: '+245',
    gu: '+1671',
    gt: '+502',
    gr: '+30',
    gq: '+240',
    gp: '+590',
    jp: '+81',
    gy: '+592',
    gf: '+594',
    ge: '+995',
    gd: '+1473',
    gb: '+44',
    ga: '+241',
    sv: '+503',
    gn: '+224',
    gm: '+220',
    gl: '+299',
    gi: '+350',
    gh: '+233',
    om: '+968',
    tn: '+216',
    jo: '+962',
    hr: '+385',
    ht: '+509',
    hu: '+36',
    hk: '+852',
    hn: '+504',
    ve: '+58',
    ps: '+970',
    pw: '+680',
    pt: '+351',
    sj: '+47',
    py: '+595',
    iq: '+964',
    pa: '+507',
    pf: '+689',
    pg: '+675',
    pe: '+51',
    pk: '+92',
    ph: '+63',
    pn: '+870',
    pl: '+48',
    pm: '+508',
    zm: '+260',
    eh: '+212',
    ee: '+372',
    eg: '+20',
    za: '+27',
    ec: '+593',
    it: '+39',
    vn: '+84',
    sb: '+677',
    et: '+251',
    so: '+252',
    gs: '+500',
    aq: '+672',
    zw: '+263',
    sa: '+966',
    es: '+34',
    er: '+291',
    me: '+382',
    md: '+373',
    mg: '+261',
    mf: '+590',
    ma: '+212',
    mc: '+377',
    uz: '+998',
    mm: '+95',
    ml: '+223',
    mo: '+853',
    mn: '+976',
    mh: '+692',
    mk: '+389',
    mu: '+230',
    mt: '+356',
    mw: '+265',
    mv: '+960',
    mq: '+596',
    mp: '+1670',
    ms: '+1664',
    mr: '+222',
    ug: '+256',
    tz: '+255',
    my: '+60',
    je: '+44',
    gg: '+44',
    mx: '+52',
    il: '+972',
    fr: '+33',
    io: '+246',
    sh: '+290',
    fi: '+358',
    fj: '+679',
    fk: '+500',
    fm: '+691',
    fo: '+298',
    ni: '+505',
    nl: '+31',
    no: '+47',
    na: '+264',
    vu: '+678',
    nc: '+687',
    ne: '+227',
    nf: '+672',
    tf: '+262',
    ng: '+234',
    nz: '+64',
    np: '+977',
    nr: '+674',
    nu: '+683',
    ck: '+682',
    xk: '+383',
    ci: '+225',
    ch: '+41',
    co: '+57',
    cn: '+86',
    cm: '+237',
    cl: '+56',
    cc: '+61',
    ca: '+1',
    cg: '+242',
    cf: '+236',
    cd: '+243',
    cz: '+420',
    cy: '+357',
    cx: '+61',
    cr: '+506',
    cw: '+599',
    cv: '+238',
    cu: '+53',
    sz: '+268',
    sy: '+963',
    sx: '+599',
    kg: '+996',
    ke: '+254',
    ss: '+211',
    sr: '+597',
    ki: '+686',
    kh: '+855',
    kn: '+1869',
    km: '+269',
    st: '+239',
    sk: '+421',
    kr: '+82',
    si: '+386',
    bv: '+55',
    kp: '+850',
    kw: '+965',
    sn: '+221',
    sm: '+378',
    sl: '+232',
    sc: '+248',
    kz: '+7',
    ky: '+1345',
    sg: '+65',
    se: '+46',
    sd: '+249',
    do: '+1809',
    dm: '+1767',
    dj: '+253',
    dk: '+45',
    vg: '+1284',
    de: '+49',
    ye: '+967',
    dz: '+213',
    us: '+1',
    uy: '+598',
    yt: '+262',
    um: '+1',
    lb: '+961',
    lc: '+1758',
    la: '+856',
    tv: '+688',
    tw: '+886',
    tt: '+1868',
    tr: '+90',
    lk: '+94',
    li: '+423',
    lv: '+371',
    to: '+676',
    lt: '+370',
    lu: '+352',
    lr: '+231',
    ls: '+266',
    th: '+66',
    tg: '+228',
    td: '+235',
    tc: '+1649',
    ly: '+218',
    va: '+379',
    vc: '+1784',
    ae: '+971',
    ad: '+376',
    ag: '+1268',
    af: '+93',
    ai: '+1264',
    vi: '+1340',
    is: '+354',
    ir: '+98',
    am: '+374',
    al: '+355',
    ao: '+244',
    as: '+1684',
    ar: '+54',
    au: '+61',
    at: '+43',
    aw: '+297',
    in: '+91',
    ax: '+358',
    az: '+994',
    ie: '+353',
    id: '+62',
    ua: '+380',
    qa: '+974',
    mz: '+25'
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGhvbmVudW1iZXIuanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsicGhvbmVudW1iZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLE9BQU8sRUFBRSxNQUFNLFdBQVcsQ0FBQTtBQUVuQyxNQUFNLENBQUMsTUFBTSxtQkFBbUIsR0FBMkI7SUFDekQsQ0FBQyxPQUFPLENBQUMsRUFBRSxDQUFDLEVBQUUsS0FBSztJQUNuQixDQUFDLE9BQU8sQ0FBQyxFQUFFLENBQUMsRUFBRSxJQUFJO0lBQ2xCLENBQUMsT0FBTyxDQUFDLEVBQUUsQ0FBQyxFQUFFLEtBQUs7SUFDbkIsQ0FBQyxPQUFPLENBQUMsRUFBRSxDQUFDLEVBQUUsS0FBSztJQUNuQixDQUFDLE9BQU8sQ0FBQyxFQUFFLENBQUMsRUFBRSxLQUFLO0lBQ25CLENBQUMsT0FBTyxDQUFDLEVBQUUsQ0FBQyxFQUFFLE1BQU07SUFDcEIsQ0FBQyxPQUFPLENBQUMsRUFBRSxDQUFDLEVBQUUsS0FBSztJQUNuQixDQUFDLE9BQU8sQ0FBQyxFQUFFLENBQUMsRUFBRSxLQUFLO0lBQ25CLENBQUMsT0FBTyxDQUFDLEVBQUUsQ0FBQyxFQUFFLEtBQUs7SUFDbkIsQ0FBQyxPQUFPLENBQUMsRUFBRSxDQUFDLEVBQUUsS0FBSztJQUNuQixDQUFDLE9BQU8sQ0FBQyxFQUFFLENBQUMsRUFBRSxLQUFLO0lBQ25CLENBQUMsT0FBTyxDQUFDLEVBQUUsQ0FBQyxFQUFFLElBQUk7Q0FDbkIsQ0FBQTtBQUVELE1BQU0sQ0FBQyxNQUFNLGtCQUFrQixHQUFHLENBQUMsS0FBYSxFQUFXLEVBQUU7O0lBQzNELE1BQU0sY0FBYyxHQUFHLEtBQUssQ0FBQyxLQUFLLENBQUMsaUJBQWlCLENBQUMsS0FBSyxJQUFJLENBQUE7SUFFOUQsTUFBTSxVQUFVLEdBQUcsQ0FBQyxNQUFBLEtBQUssQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLG1DQUFJLEVBQUUsQ0FBQyxDQUFDLE1BQU0sQ0FBQTtJQUVwRCxPQUFPLGNBQWMsSUFBSSxVQUFVLElBQUksQ0FBQyxJQUFJLFVBQVUsSUFBSSxFQUFFLENBQUE7QUFDOUQsQ0FBQyxDQUFBO0FBRUQsTUFBTSxDQUFDLE1BQU0sZ0JBQWdCLEdBQUc7SUFDOUI7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxXQUFXO0tBQ2xCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxRQUFRO0tBQ2Y7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFdBQVc7S0FDbEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFNBQVM7S0FDaEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLE9BQU87S0FDZDtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsVUFBVTtLQUNqQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsUUFBUTtLQUNmO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxXQUFXO0tBQ2xCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxjQUFjO0tBQ3JCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxPQUFPO0tBQ2Q7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLGFBQWE7S0FDcEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLGdCQUFnQjtLQUN2QjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsZUFBZTtLQUN0QjtDQUNGLENBQUE7QUFFRCxNQUFNLENBQUMsTUFBTSxjQUFjLEdBQUc7SUFDNUI7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxhQUFhO0tBQ3BCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxlQUFlO0tBQ3RCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxTQUFTO0tBQ2hCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxTQUFTO0tBQ2hCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxnQkFBZ0I7S0FDdkI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFNBQVM7S0FDaEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFFBQVE7S0FDZjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsVUFBVTtLQUNqQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsWUFBWTtLQUNuQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUscUJBQXFCO0tBQzVCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxXQUFXO0tBQ2xCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxTQUFTO0tBQ2hCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxPQUFPO0tBQ2Q7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFNBQVM7S0FDaEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFlBQVk7S0FDbkI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFNBQVM7S0FDaEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFNBQVM7S0FDaEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFlBQVk7S0FDbkI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFVBQVU7S0FDakI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFNBQVM7S0FDaEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFNBQVM7S0FDaEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFFBQVE7S0FDZjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsT0FBTztLQUNkO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxTQUFTO0tBQ2hCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxRQUFRO0tBQ2Y7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLGlDQUFpQztLQUN4QztJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsa0NBQWtDO0tBQ3pDO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSx3QkFBd0I7S0FDL0I7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFVBQVU7S0FDakI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLGVBQWU7S0FDdEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFFBQVE7S0FDZjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsZ0NBQWdDO0tBQ3ZDO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxtQkFBbUI7S0FDMUI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFVBQVU7S0FDakI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLGNBQWM7S0FDckI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFNBQVM7S0FDaEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFVBQVU7S0FDakI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFVBQVU7S0FDakI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFlBQVk7S0FDbkI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLGdCQUFnQjtLQUN2QjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsMEJBQTBCO0tBQ2pDO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxNQUFNO0tBQ2I7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLE9BQU87S0FDZDtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsT0FBTztLQUNkO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxrQkFBa0I7S0FDekI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLHlCQUF5QjtLQUNoQztJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsVUFBVTtLQUNqQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsU0FBUztLQUNoQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsT0FBTztLQUNkO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSx1Q0FBdUM7S0FDOUM7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLGNBQWM7S0FDckI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFlBQVk7S0FDbkI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLGdCQUFnQjtLQUN2QjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsU0FBUztLQUNoQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsTUFBTTtLQUNiO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxTQUFTO0tBQ2hCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxRQUFRO0tBQ2Y7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLGdCQUFnQjtLQUN2QjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsU0FBUztLQUNoQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsVUFBVTtLQUNqQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsVUFBVTtLQUNqQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsb0JBQW9CO0tBQzNCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxTQUFTO0tBQ2hCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxPQUFPO0tBQ2Q7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLGFBQWE7S0FDcEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLG1CQUFtQjtLQUMxQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsU0FBUztLQUNoQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsU0FBUztLQUNoQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsVUFBVTtLQUNqQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsNkJBQTZCO0tBQ3BDO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxlQUFlO0tBQ3RCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxNQUFNO0tBQ2I7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFNBQVM7S0FDaEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFFBQVE7S0FDZjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsZUFBZTtLQUN0QjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsa0JBQWtCO0tBQ3pCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSw2QkFBNkI7S0FDcEM7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLE9BQU87S0FDZDtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsUUFBUTtLQUNmO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxTQUFTO0tBQ2hCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxTQUFTO0tBQ2hCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxPQUFPO0tBQ2Q7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFdBQVc7S0FDbEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFFBQVE7S0FDZjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsV0FBVztLQUNsQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsU0FBUztLQUNoQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsWUFBWTtLQUNuQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsTUFBTTtLQUNiO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxXQUFXO0tBQ2xCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxVQUFVO0tBQ2pCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxRQUFRO0tBQ2Y7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLGVBQWU7S0FDdEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFFBQVE7S0FDZjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsT0FBTztLQUNkO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxtQ0FBbUM7S0FDMUM7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLCtCQUErQjtLQUN0QztJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsVUFBVTtLQUNqQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsV0FBVztLQUNsQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsU0FBUztLQUNoQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsU0FBUztLQUNoQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsT0FBTztLQUNkO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxXQUFXO0tBQ2xCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSwyQkFBMkI7S0FDbEM7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLE1BQU07S0FDYjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsYUFBYTtLQUNwQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsUUFBUTtLQUNmO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxTQUFTO0tBQ2hCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxPQUFPO0tBQ2Q7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFFBQVE7S0FDZjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsUUFBUTtLQUNmO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxZQUFZO0tBQ25CO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxPQUFPO0tBQ2Q7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFVBQVU7S0FDakI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLHlDQUF5QztLQUNoRDtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsb0JBQW9CO0tBQzNCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxRQUFRO0tBQ2Y7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFlBQVk7S0FDbkI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLG1DQUFtQztLQUMxQztJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsUUFBUTtLQUNmO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxTQUFTO0tBQ2hCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxTQUFTO0tBQ2hCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxTQUFTO0tBQ2hCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxPQUFPO0tBQ2Q7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLGVBQWU7S0FDdEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFdBQVc7S0FDbEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFlBQVk7S0FDbkI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLE9BQU87S0FDZDtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsaUJBQWlCO0tBQ3hCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxZQUFZO0tBQ25CO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxRQUFRO0tBQ2Y7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFVBQVU7S0FDakI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFVBQVU7S0FDakI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLE1BQU07S0FDYjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsT0FBTztLQUNkO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxrQkFBa0I7S0FDekI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFlBQVk7S0FDbkI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFlBQVk7S0FDbkI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFdBQVc7S0FDbEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFNBQVM7S0FDaEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFFBQVE7S0FDZjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsaUNBQWlDO0tBQ3hDO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxzQkFBc0I7S0FDN0I7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFFBQVE7S0FDZjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsVUFBVTtLQUNqQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsWUFBWTtLQUNuQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsWUFBWTtLQUNuQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsU0FBUztLQUNoQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsWUFBWTtLQUNuQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsU0FBUztLQUNoQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsU0FBUztLQUNoQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsT0FBTztLQUNkO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxPQUFPO0tBQ2Q7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLGFBQWE7S0FDcEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLGVBQWU7S0FDdEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLGFBQWE7S0FDcEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFdBQVc7S0FDbEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLE9BQU87S0FDZDtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsU0FBUztLQUNoQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsTUFBTTtLQUNiO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxnQkFBZ0I7S0FDdkI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLDBCQUEwQjtLQUNqQztJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsTUFBTTtLQUNiO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxVQUFVO0tBQ2pCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxPQUFPO0tBQ2Q7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFFBQVE7S0FDZjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsa0JBQWtCO0tBQ3pCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxVQUFVO0tBQ2pCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxNQUFNO0tBQ2I7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLGFBQWE7S0FDcEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFVBQVU7S0FDakI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFFBQVE7S0FDZjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsVUFBVTtLQUNqQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsYUFBYTtLQUNwQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsT0FBTztLQUNkO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxTQUFTO0tBQ2hCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxTQUFTO0tBQ2hCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxvQkFBb0I7S0FDM0I7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFFBQVE7S0FDZjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsa0JBQWtCO0tBQ3pCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSw4Q0FBOEM7S0FDckQ7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLHVCQUF1QjtLQUM5QjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsYUFBYTtLQUNwQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsNEJBQTRCO0tBQ25DO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSwyQkFBMkI7S0FDbEM7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLGtDQUFrQztLQUN6QztJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsT0FBTztLQUNkO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxZQUFZO0tBQ25CO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSx1QkFBdUI7S0FDOUI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLGNBQWM7S0FDckI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFNBQVM7S0FDaEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFFBQVE7S0FDZjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsWUFBWTtLQUNuQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsY0FBYztLQUNyQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsV0FBVztLQUNsQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsMkJBQTJCO0tBQ2xDO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxVQUFVO0tBQ2pCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxVQUFVO0tBQ2pCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxpQkFBaUI7S0FDeEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFNBQVM7S0FDaEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLDhDQUE4QztLQUNyRDtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsYUFBYTtLQUNwQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsV0FBVztLQUNsQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsT0FBTztLQUNkO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxVQUFVO0tBQ2pCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSx3QkFBd0I7S0FDL0I7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFdBQVc7S0FDbEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFFBQVE7S0FDZjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsMkJBQTJCO0tBQ2xDO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxZQUFZO0tBQ25CO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSw4QkFBOEI7S0FDckM7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFVBQVU7S0FDakI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLGFBQWE7S0FDcEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLE1BQU07S0FDYjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsU0FBUztLQUNoQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsT0FBTztLQUNkO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxxQkFBcUI7S0FDNUI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFNBQVM7S0FDaEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFFBQVE7S0FDZjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsY0FBYztLQUNyQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsMEJBQTBCO0tBQ2pDO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxRQUFRO0tBQ2Y7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFFBQVE7S0FDZjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsU0FBUztLQUNoQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsc0JBQXNCO0tBQzdCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxzQ0FBc0M7S0FDN0M7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFNBQVM7S0FDaEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFlBQVk7S0FDbkI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFNBQVM7S0FDaEI7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLG1DQUFtQztLQUMxQztJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsU0FBUztLQUNoQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUseUJBQXlCO0tBQ2hDO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxzQkFBc0I7S0FDN0I7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLG1CQUFtQjtLQUMxQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsZ0JBQWdCO0tBQ3ZCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsSUFBSTtRQUNWLElBQUksRUFBRSxPQUFPO0tBQ2Q7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLFFBQVE7S0FDZjtJQUNEO1FBQ0UsSUFBSSxFQUFFLElBQUk7UUFDVixJQUFJLEVBQUUsVUFBVTtLQUNqQjtDQUNGLENBQUE7QUFFRCxNQUFNLENBQUMsTUFBTSxZQUFZLEdBQUcsQ0FBQyxHQUFHLGdCQUFnQixFQUFFLEdBQUcsY0FBYyxDQUFDLENBQUE7QUFPcEUsTUFBTSxVQUFVLGdCQUFnQixDQUFFLElBQVk7SUFDNUMsT0FBTyxZQUFZLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLElBQUksS0FBSyxJQUFJLENBQUMsQ0FBQTtBQUNoRCxDQUFDO0FBRUQsTUFBTSxDQUFDLE1BQU0sU0FBUyxHQUEyQjtJQUMvQyxFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxLQUFLO0lBQ1QsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE9BQU87SUFDWCxFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE9BQU87SUFDWCxFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsT0FBTztJQUNYLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxLQUFLO0lBQ1QsRUFBRSxFQUFFLE9BQU87SUFDWCxFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLElBQUk7SUFDUixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsS0FBSztJQUNULEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsT0FBTztJQUNYLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLEtBQUs7SUFDVCxFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLEtBQUs7SUFDVCxFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsT0FBTztJQUNYLEVBQUUsRUFBRSxLQUFLO0lBQ1QsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLEtBQUs7SUFDVCxFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLEtBQUs7SUFDVCxFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsS0FBSztJQUNULEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsS0FBSztJQUNULEVBQUUsRUFBRSxLQUFLO0lBQ1QsRUFBRSxFQUFFLEtBQUs7SUFDVCxFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxLQUFLO0lBQ1QsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsS0FBSztJQUNULEVBQUUsRUFBRSxLQUFLO0lBQ1QsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsS0FBSztJQUNULEVBQUUsRUFBRSxLQUFLO0lBQ1QsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsS0FBSztJQUNULEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsS0FBSztJQUNULEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE9BQU87SUFDWCxFQUFFLEVBQUUsT0FBTztJQUNYLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxLQUFLO0lBQ1QsRUFBRSxFQUFFLEtBQUs7SUFDVCxFQUFFLEVBQUUsS0FBSztJQUNULEVBQUUsRUFBRSxLQUFLO0lBQ1QsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsS0FBSztJQUNULEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsS0FBSztJQUNULEVBQUUsRUFBRSxLQUFLO0lBQ1QsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsS0FBSztJQUNULEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxLQUFLO0lBQ1QsRUFBRSxFQUFFLEtBQUs7SUFDVCxFQUFFLEVBQUUsS0FBSztJQUNULEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLEtBQUs7SUFDVCxFQUFFLEVBQUUsS0FBSztJQUNULEVBQUUsRUFBRSxJQUFJO0lBQ1IsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxLQUFLO0lBQ1QsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLEtBQUs7SUFDVCxFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsT0FBTztJQUNYLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxLQUFLO0lBQ1QsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsS0FBSztJQUNULEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxJQUFJO0lBQ1IsRUFBRSxFQUFFLE9BQU87SUFDWCxFQUFFLEVBQUUsS0FBSztJQUNULEVBQUUsRUFBRSxLQUFLO0lBQ1QsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsT0FBTztJQUNYLEVBQUUsRUFBRSxPQUFPO0lBQ1gsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsS0FBSztJQUNULEVBQUUsRUFBRSxPQUFPO0lBQ1gsRUFBRSxFQUFFLEtBQUs7SUFDVCxFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLElBQUk7SUFDUixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLElBQUk7SUFDUixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxPQUFPO0lBQ1gsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE9BQU87SUFDWCxFQUFFLEVBQUUsS0FBSztJQUNULEVBQUUsRUFBRSxLQUFLO0lBQ1QsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsS0FBSztJQUNULEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsT0FBTztJQUNYLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsT0FBTztJQUNYLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsT0FBTztJQUNYLEVBQUUsRUFBRSxLQUFLO0lBQ1QsRUFBRSxFQUFFLE9BQU87SUFDWCxFQUFFLEVBQUUsT0FBTztJQUNYLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLEtBQUs7SUFDVCxFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsT0FBTztJQUNYLEVBQUUsRUFBRSxLQUFLO0lBQ1QsRUFBRSxFQUFFLEtBQUs7SUFDVCxFQUFFLEVBQUUsS0FBSztJQUNULEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLEtBQUs7SUFDVCxFQUFFLEVBQUUsTUFBTTtJQUNWLEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsS0FBSztJQUNULEVBQUUsRUFBRSxNQUFNO0lBQ1YsRUFBRSxFQUFFLE1BQU07SUFDVixFQUFFLEVBQUUsS0FBSztDQUNWLENBQUEifQ==